export default {
  ZH_MO: 'zh_MO',
  EN_US: 'en_US',
};
